import { RefObject, useCallback, useEffect, useState } from 'react';

const checkFocus = (ref: RefObject<HTMLElement>) => {
    if (!ref || !ref.current) {
        return;
    }

    return ref.current.contains(document.activeElement) || ref.current === document.activeElement;
};

export const useFocusMonitor = (ref: RefObject<HTMLElement>) => {
    const [focused, setFocused] = useState(checkFocus(ref));

    const monitorFocus = useCallback(() => {
        setFocused(checkFocus(ref));
    }, [setFocused, ref]);

    useEffect(() => {
        const events = ['click', 'mouseup', 'keyup'];
        events.forEach((eventName) => document.addEventListener(eventName, monitorFocus));
        return () =>
            events.forEach((eventName) => document.removeEventListener(eventName, monitorFocus));
    }, [monitorFocus]);

    return focused;
};
